"use client";

import type { WalletSessionElements } from "@whop/embedded-components-vanilla-js/types";

import { createWithFallback } from "../lib/create-with-fallback";
import { useWalletSession } from "./session";

export type {
	WithFallbackPropsOptional,
	WithFallbackPropsRequired,
} from "../lib/create-with-fallback";

export const withFallback =
	createWithFallback<WalletSessionElements>(useWalletSession);
